import * as tslib_1 from "tslib";
import { CommonModule } from '@angular/common';
import { NgModule, InjectionToken } from '@angular/core';
import { MapService } from './map.service';
import { MapComponent } from './map.component';
import { MapConfig } from './models';
// Material Component Imports
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatInputModule } from '@angular/material/input';
export var EXT_MAP_CONFIG = new InjectionToken('extMap.config');
var MapModule = /** @class */ (function () {
    function MapModule() {
    }
    MapModule_1 = MapModule;
    MapModule.forRoot = function (config) {
        return {
            ngModule: MapModule_1,
            providers: [
                {
                    provide: EXT_MAP_CONFIG,
                    useValue: config
                },
                {
                    provide: MapConfig,
                    useFactory: provideMapConfig,
                    deps: [EXT_MAP_CONFIG]
                }
            ]
        };
    }; // forRoot()
    MapModule = MapModule_1 = tslib_1.__decorate([
        NgModule({
            imports: [
                CommonModule,
                MatToolbarModule,
                MatIconModule,
                MatButtonModule,
                MatProgressBarModule,
                MatInputModule
            ],
            declarations: [MapComponent],
            exports: [MapComponent],
            providers: [MapService]
        })
    ], MapModule);
    return MapModule;
    var MapModule_1;
}());
export { MapModule };
export function provideMapConfig(config) {
    return config;
}
//# sourceMappingURL=map.module.js.map